<template>
  <div>
    <div class="container" v-if="isShow">
      <div class="card" style="padding: 5px">
        <van-tabs v-model="active">
          <van-tab title="申请详情">
            <div class="tagTitle">
              <van-tag type="success">账户充值</van-tag>
              <van-tag v-if="type != 'payment' && type != 'channel'" :type="typeArr[paymentInfo.execType]" plain style="margin-right: 15px">{{statusArr[paymentInfo.execType]}}</van-tag>
            </div>
            <div class="list-wrap van-hairline--top">
              <div class="item" style="padding-left:70px;text-indent:-70px;">
                <span class="key">合同名称：</span>
                <span class="value">{{ contInfo.contractName }}</span>
              </div>
              <div class="item" >
                <span class="key">合同编号：</span>
                <span class="value">{{ contInfo.contractNum }}</span>
              </div>
              <div class="item" v-if="paymentInfo.execCustomerName">
                <span class="key">执行客户：</span>
                <span class="value">{{ paymentInfo.execCustomerName || '--' }}</span>
              </div>
              <div class="item" v-if="paymentInfo.custName">
                <span class="key">付款单位：</span>
                <span class="value">{{ paymentInfo.custName }}</span>
              </div>
              <template v-if="dataType != 5">
                <div class="item" >
                  <span class="key" v-if="dataType == 3">垫款金额：</span>
                  <span class="key" v-else>认领金额：</span>
                  <span class="value" style="color: #ee0a24;" v-if="type == 'payment' || type == 'channel'">
                    ￥{{paymentInfo.detailPayMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.detailPayMoney)}}</span>
                  </span>
                  <span class="value" style="color: #ee0a24;" v-else>
                    ￥{{paymentInfo.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.payMoney)}}</span>
                  </span>
                </div>
                <div class="item" v-if="dataType != 3">
                  <span class="key">预充值金额：</span>
                  <span class="value" style="color: #ee0a24;">
                    ￥{{paymentInfo.preRechargeMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.preRechargeMoney)}}</span>
                  </span>
                </div>
              </template>
              <div class="item" >
                <span class="key">充值剩余金额：</span>
                <span class="value" style="color: #ee0a24;">
                  ￥{{paymentInfo.rechargeRemainMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.rechargeRemainMoney)}}</span>
                </span>
              </div>
              <div class="item" style="padding-left:98px;text-indent:-98px;" v-if="paymentInfo.inDeptName && dataType != 2">
                <span class="key">收款认领信息：</span>
                <span class="value">{{ paymentInfo.inDeptName }}<span style="color: #1989fa; margin: 0 5px;">{{ paymentInfo.inUserName }}</span></span>
              </div>
              <template v-if="type != 'payment' && type != 'channel' && dataType != 5">
                <div class="item">
                  <span class="key">现金金额(元)：</span>
                  <span class="value" style="color: #ee0a24;">
                    ￥{{paymentInfo.payRechargeMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.payRechargeMoney)}}</span>
                  </span>
                </div>
                <div class="item">
                  <span class="key">总账户币：</span>
                  <span class="value">
                    <span style="color: #07c160;">{{paymentInfo.rechargeMoney}}</span>
                  </span>
                </div>
                <div class="item">
                  <span class="key">申请时间：</span>
                  <span class="value">{{ paymentInfo.applyTime }}</span>
                </div>
              </template>
              <!-- <div class="item" v-if="paymentInfo.execType == 1">
                <span class="key">剩余金额：</span>
                <span class="value" style="color: #ee0a24;">
                  ￥{{paymentInfo.paySurplusMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.paySurplusMoney)}}</span>
                </span>
              </div> -->
              <div class="item" v-if="paymentInfo.mediaDeptName">
                <span class="key">媒介信息：</span>
                <span class="value">{{ paymentInfo.mediaDeptName }}<span style="color: #1989fa; margin: 0 5px;">{{ paymentInfo.mediaUserName }}</span></span>
              </div>
              <div class="item" v-if="paymentInfo.newMediaDeptName">
                <span class="key">转其他媒介：</span>
                <span class="value">{{ paymentInfo.newMediaDeptName }}<span style="color: #1989fa; margin: 0 5px;">{{ paymentInfo.newMediaUserName }}</span></span>
              </div>
              <project-point-detail ref="projectPointDetail" />
            </div>
            <div class="tagTitle" v-if="paymentInfo.execType && paymentInfo.execType == 1">
              <van-tag type="warning">驳回信息</van-tag>
            </div>
            <div class="list-wrap van-hairline--top" v-if="paymentInfo.execType && paymentInfo.execType == 1">
              <div class="item" >
                <span class="key">媒介驳回用户名称：</span>
                <span class="value">{{ rejectInfo.mediaUserName }}</span>
              </div>
              <div class="item" >
                <span class="key">媒介驳回时间：</span>
                <span class="value">{{ rejectInfo.mediaRejectTime }}</span>
              </div>
              <div class="item" >
                <span class="key" style="color: #ee0a24 !important;">媒介驳回原因：</span>
                <span class="value" style="color: #ee0a24;">{{ rejectInfo.mediaRejectReason }}</span>
              </div>
            </div>
            <!-- <van-tag type="success" v-if="paymentInfo.execType != 0">执行明细</van-tag>
            <div class="card" style="padding: 0px; min-height: 100px;" v-if="paymentInfo.execType != 0">
              <van-list>
                <van-cell v-for="(item,index) in executiveList" :key="index">
                  <div class="flex-between" v-if="item" style="align-items: flex-start">
                    <div class="contract_detail">
                      <div class="item">
                        <span class="key">充值账户币：</span>
                        <span class="value">{{ item.rechargeMoney }}</span>
                      </div>
                      <div class="item">
                        <span class="key">充值金额：</span>
                        <span class="value" style="color: #F56C6C">
                          ￥{{item.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(item.payMoney)}}</span>
                        </span>
                      </div>
                      <div class="item">
                        <span class="key">创建人员：</span>
                        <span class="value">{{ item.createBy }} {{ item.createTime }}</span>
                      </div>
                    </div>
                  </div>
                </van-cell>
              </van-list>
            </div> -->
          </van-tab>
          <van-tab title="操作日志" v-if="type != 'payment' && type != 'channel'">
            <div class="item">
              <van-steps direction="vertical" :active="100">
                <van-step v-for="(item,index) in operationLogList" :key="index">
                  <span style="font-weight: bold">{{item.remark}}</span>
                  <span style="margin-left: 8px">{{item.createTime}}</span>
                  <div v-for="(val,label) in item.listData" :key="label">
                    <div class="contLogSp">
                      <div>
                        <van-image style="width: 0.6rem; height: 0.6rem" :src="val.avatar" ></van-image>
                        <span style="margin-left: 10px;">{{val.userName}}</span>
                      </div>
                      <div>
                        <van-tag size="mini" :type="val.spStatus == 2?'success':val.spStatus == 3?'danger':'warning'">{{val.spStatus == 2?'已通过':val.spStatus == 3?'驳回':'审批中'}}</van-tag>
                        <span></span>
                        <span v-if="val.spTime" style="margin-left: 10px;">{{val.spTime}}</span>
                      </div>
                    </div>
                    <div v-if="val.spComment">{{val.spComment}}</div>
                  </div>
                </van-step>
              </van-steps>
            </div>
          </van-tab>
          <van-tab title="备款信息" v-if="dataType == 5">
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">执行客户：</span>
                <span class="value">{{ paymentInfo.execCustomerName }}</span>
              </div>
              <div class="item" >
                <span class="key">充值剩余金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{paymentInfo.rechargeRemainMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.rechargeRemainMoney)}}</span>
                </span>
              </div>
              <div class="item" >
                <span class="key">申请信息：</span>
                <span class="value">{{paymentInfo.deptName + '  ' + paymentInfo.userName}}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="垫款信息" v-else-if="dataType == 3">
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">本次垫款金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{paymentInfo.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.payMoney)}}</span>
                </span>
              </div>
              <div class="item" >
                <span class="key">充值剩余金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{paymentInfo.rechargeRemainMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.rechargeRemainMoney)}}</span>
                </span>
              </div>
              <div class="item" >
                <span class="key">充值过期时间：</span>
                <span class="value">{{ paymentInfo.rechargeTime }}</span>
              </div>
              <div class="item" >
                <span class="key">申请信息：</span>
                <span class="value">{{paymentInfo.deptName + '  ' + paymentInfo.userName}}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="收款信息" v-if="dataType == 1">
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">付款单位：</span>
                <span class="value">{{ paymentInfo.custName }}</span>
              </div>
              <div class="item" >
                <span class="key">收款主体：</span>
                <span class="value">{{ paymentInfo.inCompanyName }}</span>
              </div>
              <div class="item" >
                <span class="key">收款账号：</span>
                <span class="value">{{ paymentInfo.inPayBank + '  ' + paymentInfo.inPayBankNo}}</span>
              </div>
              <div class="item" >
                <span class="key">收款金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{paymentInfo.inPayMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.inPayMoney)}}</span>
                </span>
              </div>
              <div class="item">
                <span class="key">收款时间：</span>
                <span class="value">{{paymentInfo.inPayDate}}</span>
              </div>
              <div class="item">
                <span class="key">添加信息：</span>
                <span class="value">{{paymentInfo.inCreateBy + '  ' + paymentInfo.inCreateTime}}</span>
              </div>
              <div class="item" >
                <span class="key">认领金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{paymentInfo.detailPayMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.detailPayMoney)}}</span>
                </span>
              </div>
              <div class="item" >
                <span class="key">预充值金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{paymentInfo.preRechargeMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.preRechargeMoney)}}</span>
                </span>
              </div>
              <div class="item" >
                <span class="key">垫款回款金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{paymentInfo.advancesInMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.advancesInMoney)}}</span>
                </span>
              </div>
              <div class="item" >
                <span class="key">充值剩余金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{paymentInfo.rechargeRemainMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(paymentInfo.rechargeRemainMoney)}}</span>
                </span>
              </div>
              <div class="item">
                <span class="key">认领信息：</span>
                <span class="value">{{paymentInfo.inDeptName + '  ' + paymentInfo.inUserName}}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="合同信息">
            <div class="list-wrap van-hairline--top">
              <div class="item">
                <span class="key">我方签约主体机构：</span>
                <span class="value">{{ contInfo.companyName }}</span>
              </div>
              <div class="item">
                <span class="key">合同执行时间：</span>
                <span class="value">{{ contInfo.startTime }}至{{ contInfo.endTime }}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">垫款方式：</span>
                <span class="value">{{formatHandel('payType',contInfo.payType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">框架类型：</span>
                <span class="value">{{formatHandel('frameType',contInfo.frameType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">客户来源：</span>
                <span class="value">{{formatHandel('custSource',contInfo.custSource)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">授信账期：</span>
                <span class="value">{{contInfo.creditCycleType?`${contInfo.creditCycleValue}个${formatHandel('creditCycleType',contInfo.creditCycleType)}`:'--'}}</span>
              </div>
              <div class="item">
                <span class="key">合同金额(元)：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{contInfo.contractMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.contractMoney)}}</span>
                </span>
              </div>
              <div class="item">
                <span class="key">合同累计回款(元)：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{contInfo.allReturnedMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.allReturnedMoney)}}</span>
                </span>
              </div>
              <div class="item">
                <span class="key">合同授信额度(元)：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{contInfo.advancesMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.advancesMoney)}}</span>
                </span>
              </div>
              <div class="item">
                <span class="key">累计垫款总额(元)：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{contInfo.creditTotalMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.creditTotalMoney)}}</span>
                </span>
              </div>
            </div>
            <!-- <div v-if="pointList.length == 0" style="text-align: center">暂无返点数据</div>
            <van-list :finished="true" finished-text="没有更多了" v-if="pointList.length > 0">
              <van-cell v-for="(item,index) in pointList" :key="index">
                <div class="flex-between" v-if="item" style="align-items: flex-start">
                  <div style="max-width: 80%">
                    <div>
                      <span class="key"> 返点百分比值(%)：</span>
                      <span class="value">{{ item.percentage }}%</span>
                    </div>
                    <div>
                      <span class="key"> 返点消耗(元)：</span>
                      <span class="value">{{ item.useMoney }}(元)</span>
                    </div>
                    <div>
                      <span class="key"> 执行时间：</span>
                      <span class="value">{{ item.startTime }}至{{ item.endTime }}</span>
                    </div>
                  </div>
                </div>
              </van-cell>
            </van-list> -->
          </van-tab>
        </van-tabs>
      </div>
      <!-- 操作按钮区 -->
      <!-- <van-grid class="grid-wrap" :column-num="1" v-if="(paymentInfo.rechargeRemainMoney > 0 && ((this.type == 'payment' || this.type == 'channel')  || paymentInfo.execType == 1))">
        <van-grid-item>
          <div class="flex-center" @click="handleRecharge">
            <van-icon name="cash-back-record" size="22" color="#07c160" />
            <span>充值申请</span>
          </div>
        </van-grid-item>
      </van-grid> -->
      <van-grid class="grid-wrap" :column-num="2" v-if="paymentInfo.execType == 2">
        <van-grid-item>
          <div class="flex-center" v-if="!paymentInfo.mediaUserId" @click="designatedMedia">
            <van-icon name="manager-o" size="22" color="#ff976a" />
            <span>指定媒介</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <!-- v-if="paymentInfo.mediaUserId === $store.state.user.user.userId || $store.state.user.user.userId == 1" -->
          <div class="flex-center" @click="handleTransfer">
            <van-icon name="manager-o" size="22" color="#ff976a" />
            <span>转其他媒介</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-tabs v-model="listActive" color="#1989fa" title-active-color="#1989fa" v-if="rechargeList.length > 0 || channelAccountList.length > 0">
        <van-tab title="充值明细" v-if="rechargeList.length > 0">
          <!-- <div class="card" style="min-height: 0px;margin: 0; padding: 0;">
            <div class="list-wrap van-hairline--top">
              <div class="item" style="padding-left:70px;text-indent:-70px;" v-if="contInfo.channelType != 1">
                <span class="key">执行客户：</span>
                <span class="value">{{ rechargeList[0].execCustomerName }}</span>
              </div>
              <div class="item" style="padding-left:70px;text-indent:-70px;">
                <span class="key">项目名称：</span>
                <span class="value">{{ rechargeList[0].projectName }}</span>
              </div>
            </div>
          </div> -->
          <div class="card" style="padding: 5px" >
            <div>
              <!-- <van-button v-if="paymentInfo.execType == 2" size="mini" icon="coupon-o" type="primary" @click="handleMediaRechargeAll">批量充值</van-button> -->
              <!-- <van-button v-if="paymentInfo.execType == 2 || paymentInfo.execType == 3" size="mini" icon="warning-o" color="#ee0a24" @click="handleReject">驳回</van-button> -->
              <!-- <van-button v-if="paymentInfo.execType == 3" size="mini" icon="refund-o" type="warning" @click="handleBatchRefund">批量退款给客户</van-button> -->
            </div>
            <van-list>
              <van-checkbox-group v-model="checkGroup" ref="checkboxGroup">
                <van-cell v-for="(item, index) in rechargeList" :key="index" >
                  <div style="display: flex; align-items: center; width:100%">
                    <!-- <van-checkbox v-if="(item.fundType == 1 || item.fundType == 2) && item.rechargeStatus == 1" :name="item.contNewIncomeDetailExecAccountId" style="margin-right: 10px;" shape="square"></van-checkbox> -->
                    <van-checkbox v-if="item.refundType == 1" :name="item" style="margin-right: 10px;" shape="square"></van-checkbox>
                    <div style="flex: 1;color: #333;font-size: 12px">
                      <div>资金类型: {{ formatHandel('fundType',item.fundType) }}
                        &nbsp;&nbsp;&nbsp;&nbsp; 充值类型: <span v-if="item.mediaRechargeType == 1">直充</span><span v-if="item.mediaRechargeType == 2">子账户子户</span>
                      </div>
                      <div v-if="contInfo.channelType != 1 && (item.fundType == 1 || item.fundType == 2)">执行客户: {{item.execCustomerName}} </div>
                      <template v-if="item.fundType == 1 || item.fundType == 2">
                        <div style="padding-left:50px; text-indent:-50px;">项目名称: {{`【${item.calculationMethodStr}】${getValue(item.projectName)} | ${item.industryName?item.industryName : '-'}`}} </div>
                        <div>账户名称: {{ item.accountName || '--' }} </div>
                        <div>账户ID: {{ item.accountNo }}</div>
                        <div>账户币: {{ item.rechargeMoney }}  &nbsp;&nbsp;&nbsp;&nbsp; 现金金额(元)：: {{ item.payMoney }}元</div>
                        <div v-if="item.serviceId">所属服务商ID: {{ item.serviceId }} <span v-if="item.subAccountId">子账户ID: {{ item.subAccountId }}</span></div>
                      </template>
                      <div v-if="(item.fundType == 1 || item.fundType == 2)">充值状态: <van-tag size="mini" :type="typeArr2[item.rechargeStatus]">{{ item.refundType == 2?statusArr3[item.rechargeStatus]:statusArr2[item.rechargeStatus] }}</van-tag></div>
                      <div v-if="item.rechargeStatus !== 3">是否在线充值:
                        <span v-if="item.onLineType == 1">否</span>
                        <span v-if="item.onLineType == 2">是</span>
                      </div>
                      <template v-if="item.rechargeStatus != 1 && item.rechargeStatus != 3">
                        <div>媒介充值时间： {{item.mediaTime}} &nbsp;&nbsp;&nbsp;&nbsp; 媒介充值用户: {{item.mediaUserName}}</div>
                        <!-- <div v-if="item.mediaUrl">媒介充值图片:
                          <van-button type="info" size="mini" plain @click="showImg(item.mediaUrl)" v-if="item.mediaUrl">点击查看</van-button>
                        </div> -->
                      </template>
                      <template v-if="item.rechargeStatus === 3">
                        <div>驳回时间： {{item.mediaTime || '--'}} &nbsp;&nbsp;&nbsp;&nbsp; 驳回用户: {{item.mediaUserName}}</div>
                      </template>
                      <div v-if="item.remark">备注: <span style="color: #ee0a24">{{ item.remark }}</span></div>
                      <!-- <template v-if="item.rechargeStatus == 4">
                        <div>退款用户名称: {{ item.refundUserName }} &nbsp;&nbsp;&nbsp;&nbsp;
                          退款类型:
                          <span v-if="item.refundType == 1">退款</span>
                          <span v-if="item.refundType == 2">调拨</span></div>
                        <div v-if="item.refundReason" style="padding-left:50px; text-indent:-50px;">退款原因: {{ item.refundReason }}</div>
                        <div>退款时间: {{ item.refundTime }}</div>
                        <div>现金金额: {{ item.refundPayMoney }} &nbsp;&nbsp;&nbsp;&nbsp; 帐户币: {{ item.refundRechargeMoney }}</div>
                        <div v-if="item.refundUrl">媒介退款图片:
                          <van-button type="info" size="mini" plain @click="showImg(item.refundUrl)" v-if="item.refundUrl">点击查看</van-button>
                        </div>
                      </template> -->
                    </div>
                    <!-- <van-tag size="mini" v-if="(item.fundType == 1 || item.fundType == 2)" :type="typeArr2[item.rechargeStatus]">{{ item.refundType == 1?statusArr2[item.rechargeStatus]:statusArr3[item.rechargeStatus] }}</van-tag> -->
                  </div>
                  <div style="text-align: center; margin-top: 10px">
                    <van-button size="small" type="warning" v-if="item.rechargeStatus == 1 && (item.fundType == 1 || item.fundType == 2) && paymentInfo.execType == 2 && item.isHide !== 1"
                      @click="handleMediaRecharge(item, 'online')" style="padding: 0 20px; border-radius: 5px;margin-right: 10px;">在线充值</van-button>
                    <van-button size="small" type="info" v-if="item.rechargeStatus == 1 && (item.fundType == 1 || item.fundType == 2) && paymentInfo.execType == 2"
                      @click="handleMediaRecharge(item, 'media')" style="padding: 0 20px; border-radius: 5px;margin-right: 10px;">媒介充值</van-button>
                    <!-- <van-button size="small" color="#ee0a24" v-if="item.rechargeStatus == 2 && item.onLineType == 2"
                      @click="handleRefund(item)" style="padding: 0 20px; border-radius: 5px;">在线退款</van-button> -->
                    <van-button size="small" color="#ee0a24" v-if="item.rechargeStatus == 1 && (item.fundType == 1 || item.fundType == 2)"
                      @click="handleReject(item)" style="padding: 0 20px; border-radius: 5px;">驳回</van-button>
                  </div>
                </van-cell>
              </van-checkbox-group>
            </van-list>
          </div>
        </van-tab>
        <van-tab title="渠道分账明细" v-if="channelAccountList.length > 0">
          <div class="card" style="padding: 5px" >
            <div>
              <!-- <van-button v-if="paymentInfo.execType == 2" size="mini" icon="coupon-o" type="primary" @click="handleMediaRechargeAll">批量充值</van-button> -->
              <!-- <van-button v-if="paymentInfo.execType == 2 || paymentInfo.execType == 3" size="mini" icon="warning-o" color="#ee0a24" @click="handleReject">驳回</van-button> -->
              <!-- <van-button v-if="paymentInfo.execType == 3" size="mini" icon="refund-o" type="warning" @click="handleBatchRefund">批量退款给客户</van-button> -->
            </div>
            <van-list>
              <van-cell v-for="(item, index) in channelAccountList" :key="index" >
                <div style="display: flex; align-items: center; width:100%">
                  <div style="flex: 1;color: #333;font-size: 12px">
                    <div v-if="item.execCustomerName">执行客户: {{item.execCustomerName}} </div>
                    <div>合同编号: {{item.contractNum}} </div>
                    <div style="padding-left:50px; text-indent:-50px;">合同名称: {{item.contractName}} </div>
                    <div style="padding-left:50px; text-indent:-50px;">行业名称: {{item.industryName}} </div>
                    <div style="padding-left:50px; text-indent:-50px;">项目名称: {{item.projectName}} </div>
                    <div>计算方式：
                      <span v-if="item.calculationMethod === 1">返货</span>
                      <span v-if="item.calculationMethod === 2">返现</span>
                    </div>
                    <div>账户ID: {{ item.accountId }} &nbsp;&nbsp;&nbsp;&nbsp; 渠道返点: {{ item.channelPercentage }}%</div>
                    <div>渠道现金: {{ item.channelPayMoney }}  &nbsp;&nbsp;&nbsp;&nbsp; 充值账户币: <span style="color: #ee0a24">{{ item.rechargeMoney }}</span></div>
                    <div>是否充值成功:
                      <van-tag size="mini" type="danger" v-if="item.cdaType == 1">否</van-tag>
                      <van-tag size="mini" type="success" v-if="item.cdaType == 2">是</van-tag>
                    </div>
                    <div>部门/业务员: {{ item.deptName }}<span style="color: #1989fa; margin: 0 5px;">{{ item.bussUserName }}</span></div>
                    <div>创建时间: {{ item.createTime }}</div>
                  </div>
                </div>
              </van-cell>
            </van-list>
          </div>
        </van-tab>
      </van-tabs>

      <!-- 转其他媒介 -->
      <van-dialog v-model="mediaVisible" title="转其他媒介" width="95%" style="height:50%" class="media" :beforeClose="mediaBeforeClose" show-cancel-button>
        <van-form ref="mediaForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <!-- @click="showPicker('dept')" -->
          <van-field readonly clickable v-model="mediaForm.deptName" label="部门" placeholder="请选择部门" :rules="[{ required: true }]" required />
          <van-field readonly clickable v-model="mediaForm.userName" @click="showPicker('user')" label="媒介人员" placeholder="请选择媒介人员" :rules="[{ required: true }]" required />
        </van-form>
      </van-dialog>

      <!-- 指定媒介 -->
      <van-dialog v-model="designatedVisible" title="指定媒介" width="95%" style="height:50%" class="media" :beforeClose="saveDesignated" show-cancel-button>
        <van-form ref="designatedForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <!-- @click="showPicker('dept')" -->
          <!-- <van-field readonly clickable v-model="mediaForm.deptName" label="部门" placeholder="请选择部门" :rules="[{ required: true }]" required /> -->
          <van-field readonly clickable v-model="designatedForm.mediaUserName" @click="showPicker('user')" label="媒介人员" placeholder="请选择媒介人员" :rules="[{ required: true }]" required />
        </van-form>
      </van-dialog>
      <!-- 充值申请 -->
      <van-dialog v-model="rechargeVisible" title="充值申请" width="95%" style="height:80%" class="editClue" show-cancel-button>
        <van-form ref="rechargeForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-button v-if="rechargeForm.flowList.length == 0" class="authId_topBtn" round block type="primary" native-type="button" size="small" @click="addExecutive">+添加充值明细</van-button>
          <van-collapse v-model="activeNames">
            <van-collapse-item :name="index" v-for="(item,index) in rechargeForm.flowList" :key="index+'01'" style="border-bottom: dashed 2px #1989fa;">
              <template #title>
                <div class="list_title">
                  <van-tag type="success" size="large">执行明细({{index + 1}})</van-tag>
                  <div style="margin-right: 10px;">
                    <van-icon name="add-o" size="30" color="#07c160" @click.stop="addExecutive" />
                    <van-icon name="delete-o" size="30" color="#ee0a24" @click.stop="delExecutive(index)" />
                  </div>
                </div>
              </template>
              <van-field readonly clickable v-model="item.fundTypeName" @click="showPicker('fundType',index)" label="资金类型" placeholder="请选择资金类型" :rules="[{ required: true }]" required />
              <!-- <van-field v-if="(item.fundType == '1' || item.fundType == '2') && (paymentInfo.custSource == 2 || contInfo.channelType == 2)" v-model="item.execCustomerName" label="执行客户"
                placeholder="请选择执行客户" readonly clickable  @click="typeDetailId == 'advancesRechargeId'?'':showPicker('execCustomers',index)" :rules="[{ required: true }]" required /> -->
              <van-field v-if="(item.fundType == 1 || item.fundType == 2)" v-model="item.projectName" label="项目名称"
                placeholder="请选择项目名称" readonly clickable  @click="showPicker('projects',index)" :rules="[{ required: true }]" required />
              <template v-if="item.fundType == '1' || item.fundType == '2' && item.projectName">
                <van-cell required :border="false">
                  <template #title>
                    <div>账户ID
                      <van-tag type="primary" v-if="item.projectId" @click.stop="selectAuthIds(index)" class="tag_button" style="margin-left: 30px;">+ID明细</van-tag>
                    </div>
                  </template>
                </van-cell>
                <van-field v-model="item.authIds" rows="3" readonly autosize clearable placeholder="请点击按钮填入账户ID" type="textarea" show-word-limit style="border: 1px solid #d4d4d4; border-radius: 5px" :rules="[{ required: true }]" />
                <van-field v-model="item.rechargeMoney" disabled label="账户币" placeholder="请先填入账户ID" type="number" :rules="[{ required: true }]" required />
              </template>
              <van-field v-model="item.payMoney" :disabled="(item.fundType == '1' || item.fundType == '2') || (!item.fundType && item.fundType != 0)" @input="getAllPayMoney(index)" label="现金金额(元)" placeholder="请输入现金金额" type="number" :rules="[{ required: true }]" required >
                <template slot="right-icon">￥</template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
          <div class="money_total" v-if="rechargeForm.flowList.length > 0">
            <div class="total_title">总计</div>
            <div class="totle_divider"></div>
            <div class="item" >
              <span class="key">账户币：</span>
              <span class="value">{{ rechargeForm.rechargeMoney }}</span>
            </div>
            <div class="item" >
              <span class="key">现金金额(元)：</span>
              <span class="value">
                ￥{{rechargeForm.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(rechargeForm.payMoney)}}</span>
              </span>
            </div>
          </div>
        </van-form>
        <div class="footer">
          <van-button hairline type="defaut" plain @click="rechargeVisible = false">取消</van-button>
          <van-button hairline type="primary" plain @click="saveRecharge">媒介充值</van-button>
          <van-button hairline type="warning" plain @click="saveRechargeOnline">在线充值</van-button>
        </div>
      </van-dialog>

      <!-- 在线充值 -->
      <van-dialog v-model="onlineVisible" title="在线充值" width="95%" style="height:80%" class="editClue" show-cancel-button>
        <div style="height:103%; overflow-y: scroll;">
          <van-collapse v-model="activeNamesOnline">
            <van-collapse-item :name="index" v-for="(item,index) in rechargeForm.execAccountList" :key="index+'01'" style="border-bottom: dashed 2px #1989fa;">
              <template #title>
                <div class="list_title">
                  <van-tag type="success" size="large">在线充值({{index + 1}})</van-tag>
                </div>
              </template>
              <van-field readonly clickable v-model="item.serviceName" @click="showPicker('serviceId',index)" label="所属服务商ID" placeholder="请选择所属服务商ID" :rules="[{ required: true }]" required />
              <van-cell title="充值类型：" required>
                <template>
                  <!-- :disabled="accountType == 2" -->
                  <van-radio-group v-model="item.mediaRechargeType" direction="horizontal" :disabled="accountType == 2">
                    <van-radio :name="1" clickable @click="setType">直充</van-radio>
                    <van-radio :name="2" clickable @click="setType">子账户子户</van-radio>
                  </van-radio-group>
                </template>
              </van-cell>
              <van-field v-if="item.mediaRechargeType === 2" readonly clickable v-model="item.subAccountName" @click="showPicker('subAccountId',index)" label="子账户ID" placeholder="请选择子账户ID" :rules="[{ required: true }]" required />
              <van-field v-if="accountType == 1" readonly clickable v-model="item.tenFundTypeName" @click="showPicker('tenFundType', index)" label="资金账号类型" placeholder="请选择资金账号类型" :rules="[{ required: true }]" required />
              <van-cell :title="'账户ID：' + item.accountNo" />
              <van-cell :title="'账户币：' + item.rechargeMoney" />
              <van-cell :title="'现金金额(元)：' + item.payMoney" />
            </van-collapse-item>
          </van-collapse>
        </div>
        <div class="footer2">
          <van-button hairline type="defaut" plain @click="onlineVisible = false">取消</van-button>
          <van-button hairline type="primary" plain @click="saveOnline">确认充值</van-button>
        </div>
      </van-dialog>

      <van-dialog v-model="resultVisible" class="contract" width="97%" style="height: 80%;overflow: scroll;" title="充值结果" :showConfirmButton = 'false' :close-on-click-overlay="true">
        <van-list class="van-list" style="height: 60%">
          <van-cell v-for="(item,index) in resultList" :key="index">
            <div class="flex-between">
              <div style="color: #333; font-size: 12px">
                <div>资金类型: {{ formatHandel('fundType',item.fundType) }}</div>
                <div v-if="contInfo.channelType != 1 && (item.fundType == 1 || item.fundType == 2)">执行客户: {{item.execCustomerName}} </div>
                <template v-if="item.fundType == 1 || item.fundType == 2">
                  <div style="padding-left:50px; text-indent:-50px;">项目名称: {{`${getValue(item.projectName)} | ${item.industryName?item.industryName : '-'}`}} </div>
                  <div>账户名称: {{ item.accountName || '--' }}</div>
                  <div>账户ID: {{ item.accountNo }}</div>
                  <div>账户币: {{ item.rechargeMoney }}  &nbsp;&nbsp;&nbsp;&nbsp; 现金金额(元)：: {{ item.payMoney }}元</div>
                  <div v-if="item.serviceId">所属服务商ID: {{ item.serviceId }} <span v-if="item.subAccountId">子账户ID: {{ item.subAccountId }}</span></div>
                </template>
                <div>充值状态:
                  <span v-if="item.rechargeStatus == 1" style="color: #F56C6C">未充值</span>
                  <span v-if="item.rechargeStatus == 3" style="color: #E6A23C">驳回</span>
                  <span v-if="item.rechargeStatus == 2" style="color: #67C23A">已充值</span>
                  <span v-if="item.rechargeStatus == 4" style="color: #F56C6C">退款</span>
                </div>
                <template v-if="item.rechargeStatus == 2">
                  <div>媒介充值用户: {{item.mediaUserName}}</div>
                  <div>媒介充值时间： {{item.mediaTime}}</div>
                  <div v-if="item.mediaUrl">媒介充值图片:
                    <van-button type="info" size="mini" plain @click="showImg(item.mediaUrl)" v-if="item.mediaUrl">点击查看</van-button>
                  </div>
                </template>
                <div v-if="item.remark">失败原因: <span style="color: #ee0a24">{{ item.remark }}</span></div>
              </div>
            </div>
          </van-cell>
        </van-list>
        <van-cell style="color: #ff976a;" :title="'注：如充值结果返回的充值状态是未充值，业务员可以到已申请的页面再次操作在线充值。'" />
      </van-dialog>

      <van-dialog v-model="authIdsVisible" title="账户ID管理" width="98%" style="height:80%" class="verifyClue" :beforeClose="authIdsBeforeClose" show-cancel-button>
        <van-form ref="authIdsForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-button style="margin: 5px; width: 30%" round block type="primary" native-type="button" size="small" @click="handleAccountID">+添加账户ID</van-button>
          <div class="vant-table">
            <table cellspacing="0" style="width:100%" class="table">
              <tr>
                <th class="th">账户ID</th>
                <th class="th">账户币/现金(元)</th>
              </tr>
              <tr v-for="(item,index) in authIdsForm.authIdsList" :key="index + '01'" class="list-tr">
                <td>
                  <div style="display: flex;align-items: center;">
                    <van-icon v-if="index != 0" name="delete-o" size="20" color="#ee0a24" @click.stop="delAuthId(index)" />
                  </div>
                  <van-field readonly clickable v-model="item.accountNo" @click="showPicker('accountNo',index)" label="ID" placeholder="请选择账户ID" :rules="[{ required: true }]" required />
                </td>
                <td>
                  <van-field v-model="item.rechargeMoney" @blur="getPayMoney('rechargeMoney',item.rechargeMoney,index)" :disabled="!item.accountNo" label="币" placeholder="请输入账户币" type="number" :rules="[{ required: true }]" required />
                  <van-field v-model="item.payMoney" @blur="getPayMoney('payMoney',item.payMoney,index)" :disabled="!item.accountNo" label="现" placeholder="请输入现金金额" type="number" :rules="[{ required: true }]" required >
                    <template slot="right-icon">￥</template>
                  </van-field>
                </td>
              </tr>
              <tr>
                <td>合计</td>
                <td style="text-align: left;padding-left: 20px;">
                  <div>币:{{ authIdsForm.rechargeMoney }}</div>
                  <div>现:￥{{authIdsForm.payMoney}}</div>
                  <!-- <span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(authIdsForm.payMoney)}}</span> -->
                </td>
              </tr>
            </table>
            <div style="margin: 5px; display: flex; justify-content: right;">
              <van-button style="width: 30%" round block type="info" native-type="button" size="small" @click="addAuthId">+添加ID明细</van-button>
            </div>
          </div>
          <!-- <van-collapse v-model="activeNamesID">
            <van-collapse-item :name="index" v-for="(item,index) in authIdsForm.authIdsList" :key="index+'01'" style="border-bottom: dashed 2px #1989fa;">
              <template #title>
                <div class="list_title">
                  <van-tag type="success" size="large">账户ID({{index + 1}})</van-tag>
                  <div style="margin-right: 10px;">
                    <van-icon name="add-o" size="30" color="#07c160" @click.stop="addAuthId" />
                    <van-icon v-if="index != 0" name="delete-o" size="30" color="#ee0a24" @click.stop="delAuthId(index)" />
                  </div>
                </div>
              </template>
              <van-field readonly clickable v-model="item.accountNo" @click="showPicker('accountNo',index)" label="账户ID" placeholder="请选择账户ID" :rules="[{ required: true }]" required>
                <template #button>
                  <van-button type="primary" native-type="button" size="small" @click.stop="handleAccountID">+添加</van-button>
                </template>
              </van-field>
              <van-field v-model="item.rechargeMoney" @blur="getPayMoney('rechargeMoney',item.rechargeMoney,index)" :disabled="!item.accountNo" label="账户币" placeholder="请输入账户币" type="number" :rules="[{ required: true }]" required />
              <van-field v-model="item.payMoney" @blur="getPayMoney('payMoney',item.payMoney,index)" :disabled="!item.accountNo" label="现金金额(元)" placeholder="请输入现金金额" type="number" :rules="[{ required: true }]" required >
                <template slot="right-icon">￥</template>
              </van-field>
            </van-collapse-item>
          </van-collapse>
          <div class="money_total">
            <div class="total_title">总计</div>
            <div class="totle_divider"></div>
            <div class="item" >
              <span class="key">账户币：</span>
              <span class="value">{{ authIdsForm.rechargeMoney }}</span>
            </div>
            <div class="item" >
              <span class="key">现金金额(元)：</span>
              <span class="value">
                ￥{{authIdsForm.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(authIdsForm.payMoney)}}</span>
              </span>
            </div>
          </div> -->
          <!-- <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '10px 0 0 0' }">总计</van-divider>
          <van-field v-model="authIdsForm.rechargeMoney" disabled label="账户币" placeholder="请填写单个账户ID" type="number" :rules="[{ required: true }]" required />
          <van-field v-model="authIdsForm.payMoney" disabled label="现金金额(元)" placeholder="请填写单个账户ID" type="number" :rules="[{ required: true }]" required >
            <template slot="right-icon">￥</template>
          </van-field> -->
        </van-form>
      </van-dialog>

      <!-- 详情之authsId的详情 -->
      <van-dialog v-model="authIdsDetailVisible" title="账户ID详情" width="95%" style="height:80%" class="verifyClue">
        <div class="card" style="padding: 5px; overflow: scroll; height: 98%" v-if="paymentInfo.execType != 0">
          <van-list>
            <van-cell v-for="(item,index) in authIdsDetailList" :key="index">
              <div class="flex-between" v-if="item" style="align-items: flex-start">
                <div class="contract_detail">
                  <div class="item">
                    <span class="key">账户ID：</span>
                    <span class="value">{{ item.accountNo }}</span>
                  </div>
                  <div class="item">
                    <span class="key">账户币：</span>
                    <span class="value" style="color: #07c160;">{{ item.rechargeMoney }}</span>
                  </div>
                  <div class="item">
                    <span class="key">执行金额：</span>
                    <span class="value" style="color: #F56C6C">
                      ￥{{item.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(item.payMoney)}}</span>
                    </span>
                  </div>
                </div>
              </div>
            </van-cell>
          </van-list>
        </div>
      </van-dialog>
      <!-- <van-image-preview v-model="imageShow" :images="imageArr">
        <template v-slot:index>第{{ index }}页</template>
      </van-image-preview> -->
      <van-popup v-model="picker.visible" position="bottom">
        <van-search v-model="authIdQuery.accountId" placeholder="请输入账户ID查询" @search="onSearch" @input="onSearch" v-if="picker.formKey == 'accountNo'" />
        <van-search v-model="queryAccountId" placeholder="请输入子账户ID查询" @search="searchSubAccountId" @input="searchSubAccountId" v-if="picker.formKey == 'subAccountId'" />
        <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
      </van-popup>
      <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :type="datePicker.type" @confirm="dateConfirm" />

      <van-image-preview v-model="imageShow" :images="imageArr"></van-image-preview>
      <!-- 项目绑定账户ID -->
      <account-id ref="accountId"></account-id>

      <van-dialog v-model="mediaRechargeVisible" :title="mediaRechargeForm.onLineType==2?'在线充值':'媒介充值'" width="95%" style="height:60%" class="mediaRecharge_form" show-cancel-button :beforeClose="saveMediaRecharge">
        <van-form ref="mediaRechargeForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-field readonly clickable v-model="mediaRechargeForm.serviceName" @click="showPicker('serviceId')" label="所属服务商ID" placeholder="请选择所属服务商ID" :rules="[{ required: true }]" required />
          <template v-if="mediaRechargeForm.accountType === 2">
            <!-- <van-cell v-if="accountBalance.deposit_amount" title="需预留保证金：" :value="accountBalance.deposit_amount" /> -->
            <van-cell v-if="accountBalance.cash_transfer_balance || accountBalance.cash_transfer_balance == 0" title="所属服务商通用余额：" :value="accountBalance.cash_transfer_balance" />
          </template>
          <template v-if="mediaRechargeForm.accountType === 1">
            <van-cell v-for="(item, index) in accountBalance.mapList" :key="index" :title="item.fundType" :value="item.balance" />
          </template>
          <van-cell title="充值类型：" required>
            <template>
              <!-- :disabled="rechargeList.length > 0 && rechargeList[0].accountType == 2" -->
              <van-radio-group v-model="mediaRechargeForm.mediaRechargeType" direction="horizontal" :disabled="rechargeList.length > 0 && rechargeList[0].accountType == 2">
                <van-radio :name="1" clickable>直充</van-radio>
                <van-radio :name="2" clickable>子账户子户</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field v-if="mediaRechargeForm.mediaRechargeType === 2" readonly clickable v-model="mediaRechargeForm.subAccountName" @click="showPicker('subAccountId')" label="子账户ID" placeholder="请选择子账户ID" :rules="[{ required: true }]" required />
          <van-field v-if="rechargeList.length > 0 && rechargeList[0].accountType == 1" readonly clickable v-model="mediaRechargeForm.tenFundTypeName" @click="showPicker('tenFundType')" label="资金账号类型" placeholder="请选择资金账号类型" :rules="[{ required: true }]" required />
          <!-- <van-field v-if="mediaRechargeForm.onLineType != 2" v-model="mediaRechargeForm.mediaUrl" label="充值截图" placeholder="请点击下方上传充值截图" :rules="[{ required: true }]" required readonly />
          <van-uploader v-if="mediaRechargeForm.onLineType != 2" class="pictureList" v-model="pictureList" :max-count="1" :after-read="uploadPictureFiles" :before-read="beforeRead" :before-delete="handleRemove" @oversize="onOversize" :max-size="10000 * 1024" />
          <div v-if="mediaRechargeForm.onLineType != 2" style="color: #ff976a; font-size: 14px;">只能上传一张jpg/png格式图片，且不超过10mb</div> -->
          <template v-if="mediaRechargeForm.onLineType != 2">
            <van-field v-model="mediaRechargeForm.consumeDate" label="充值时间" placeholder="请选择充值时间" readonly clickable @click="showTimePicker('consumeDate')" :rules="[{ required: true }]" required />
            <van-cell style="color: #ff976a;" :title="'注：请选择线下实际充值时间。'" />
          </template>
        </van-form>
      </van-dialog>
      <van-popup v-model="datetimePicker.showDate" position="bottom">
        <van-datetime-picker v-model="datetimePicker.date" type="datetime" :title="datetimePicker.title" :min-date="datetimePicker.minDate" :max-date="datetimePicker.maxDate" @confirm="datetimePickerConfirm" @cancel="datetimePicker.visible = false" />
      </van-popup>

      <van-dialog v-model="rejectVisible" title="驳回" width="95%" style="height:30%" class="reject_form" show-cancel-button :beforeClose="saveReject">
        <van-form ref="rejectForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-field v-model="rejectForm.mediaRejectReason" label="驳回原因" placeholder="请输入驳回原因" :rules="[{ required: true }]" required />
        </van-form>
      </van-dialog>

      <!-- 退款 -->
      <refund ref="refund"></refund>

      <!-- 批量退款给客户 -->
      <batch-refund ref="batchRefund"></batch-refund>
    </div>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import channel from '@/api/channel/channel'
import advances from '@/api/channel/advances'
import { getValue } from '@/utils/util'
import { getUserDeptListByRole } from '@/api/system/user'
import { listDept } from '@/api/admi/dept'
import newContract from '@/api/cont/newContract'
import { Toast, Dialog, ImagePreview, Checkbox, CheckboxGroup, DatetimePicker } from 'vant'
import AccountId from '@/views/channel/recharge/AccountId'
import ProjectPointDetail from '@/views/cont/components/ProjectPointDetail'
import Refund from '@/views/channel/recharge/Refund'
import BatchRefund from '@/views/channel/recharge/BatchRefund'

// import Empty from '@/components/common/Empty'
export default {
  components: {
    // Empty,
    AccountId,
    ProjectPointDetail,
    Refund,
    BatchRefund,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [DatetimePicker.name]: DatetimePicker
  },
  watch: {

  },
  data() {
    return {
      isShow: false,
      active: 0,
      activeName: '',
      contractId: '',
      contNewIncomeDetailId: '',
      contInfo: {}, // 合同信息
      paymentInfo: {},
      // paymentInfo: {},
      pointList: [],
      executiveList: [],
      flowList: [],
      finished: true,
      operationLogList: [], // 操作日志

      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        type: 'single',
        formKey: ''
      },
      statusArr: ['未申请', '驳回', '已申请', '已充值'],
      typeArr: ['danger', 'warning', 'primary', 'success'],
      statusArr2: ['', '未充值', '已充值', '驳回', '退款'],
      statusArr3: ['', '未充值(调拨)', '已充值(调拨)', '驳回(调拨)', '退款(调拨)'],
      typeArr2: ['', 'danger', 'success', 'warning', 'danger'],
      options: {
        accountTypeOptions: [{ dictLabel: '腾讯', dictValue: 1 }, { dictLabel: '抖音', dictValue: 2 }, { dictLabel: '头条', dictValue: 3 }, { dictLabel: 'B站', dictValue: 4 }],
        fundTypeOptions: [],
        checkStatusOptions: [],
        frameTypeOptions: [],
        // fundTypeOptions: [],
        checkReasonTypeOptions: [],
        fileTypeOptions: [],
        creditCycleTypeOptions: [],
        tenFundTypeOptions: []
      },
      bindVisible: false,
      bindForm: {
        execCustomerId: null,
        execCustomerName: null,
        projectId: null,
        projectName: null,
        accountType: 1,
        accountTypeName: '腾讯',
        startDateStr: null,
        endDateStr: null,
        accountIds: null,
        dataType: null
      },
      bindResultVisible: false,
      bindResult: '',
      mediaVisible: false,
      mediaForm: {
        deptName: null,
        deptId: null,
        userName: null,
        userId: null
      },
      deptList: [],
      userList: [],
      rechargeVisible: false,
      rechargeForm: {
        contractId: null,
        contNewIncomeDetailId: null,
        flowList: [],
        payMoney: null,
        rechargeMoney: null
      },
      activeNames: [0],
      index: null,
      activeNamesID: [0],
      authIdsVisible: false,
      authIdsForm: {
        payMoney: 0,
        rechargeMoney: 0,
        authIdsList: [{
          accountNo: null,
          payMoney: null,
          rechargeMoney: null
        }]
      },
      flowIndex: null,
      authIdQuery: {
        pageNum: 1,
        pageSize: 100,
        projectId: null,
        accountId: null
      },
      accountNoList: [],
      authIdsDetailVisible: false,
      authIdsDetailList: [],

      type: null,
      typeDetailId: null,
      dataType: null,
      mainId: null,
      mainDetailId: null,

      execCustomerList: [],
      projectList: [],

      listActive: 0,
      execCustomerId: null,
      execCustomerName: null,
      agentBusinessMoney: null,
      rechargeList: [],
      channelAccountList: [],
      rejectInfo: {},
      checkGroup: [],
      imageShow: false,
      imageArr: [],
      mediaRechargeVisible: false,
      mediaRechargeForm: {
        serviceId: null,
        mediaRechargeType: 1,
        consumeDate: null,
        subAccountId: null,
        mediaUrl: null,
        tenFundType: null,
        ids: []
      },
      datetimePicker: {
        showDate: false,
        minDate: new Date(2023, 0, 1),
        maxDate: new Date(),
        formKey: '',
        title: ''
      },
      accountBalance: {},
      serviceIdList: [],
      queryAccountId: null,
      subAccountIdList: [],
      pictureList: [],
      rejectVisible: false,
      rejectForm: {
        mediaRejectReason: null,
        execId: null
      },

      // 指定媒介
      designatedVisible: false,
      designatedForm: {
        dataType: null,
        contNewIncomeDetailId: null,
        mediaUserId: null,
        mediaUserName: null
      },

      accountType: null,
      onlineVisible: false,
      makeCardDDataListCopy: [],
      activeNamesOnline: [0],
      resultVisible: false,
      resultList: []
    }
  },
  async created() {
    await this.getDicts('sys_money_type').then(res => {
      this.options.fundTypeOptions = this.setDictToInt(res)
    })
    const { contractId, contNewIncomeDetailId, dataType, type } = this.$route.query
    this.contractId = contractId
    this.type = type
    this.dataType = dataType
    // if (type == 'payment') {
    //   api = payment
    //   this.dataType = 1
    //   this.typeDetailId = 'contNewIncomeDetailId'
    // } else if (type == 'channel') {
    //   api = channel
    //   this.dataType = 2
    //   this.typeDetailId = 'needDetailId'
    // } else if (type == 'advances') {
    //   api = advances
    //   this.dataType = 3
    //   this.typeDetailId = 'advancesRechargeId'
    //   await this.getDicts('money_type_advances').then(res => {
    //     this.options.fundTypeOptions = this.setDictToInt(res)
    //   })
    // }
    this.mainDetailId = contNewIncomeDetailId
    await this.getOptions()
    await this.getPaymentInfo()
    if (type == 'advances') {
      await payment.getAdvances(this.paymentInfo.contAdvancesId).then(res => {
        if (res.code == 200) {
          this.paymentInfo.payMoney = res.data.payMoney
          this.paymentInfo.rechargeRemainMoney = res.data.rechargeRemainMoney
          this.paymentInfo.rechargeTime = res.data.rechargeTime
          this.agentBusinessMoney = res.data.agentBusinessMoney
        }
      })
      await this.getDicts('money_type_advances').then(res => {
        this.options.fundTypeOptions = this.setDictToInt(res)
      })
    }
    // await this.getRechargeInfo()
    await this.getContractInfo()
    if (this.paymentInfo.execType != 0) {
      await this.getRechargeList()
    }
    if (this.type === 'channel') {
      await this.getChannelAccountList()
    }
    if (this.paymentInfo.execType == 1) {
      await this.getRejectInfo()
    }

    if ((type === 'advances') && this.paymentInfo.custSource == 2) {
      this.execCustomerId = this.paymentInfo.execCustomerId
      this.execCustomerName = this.paymentInfo.execCustomerName
      await this.$refs.projectPointDetail.getProjectList(2, this.execCustomerId, this.execCustomerName, this.agentBusinessMoney)
    } else if (((type === 'payment' || type === 'paymentReject') && this.contInfo.channelType == 2) || type === 'channel' || type === 'channelReject') {
      // await payment.getExecCustomerByCustName({ contractId: this.contInfo.contractId, execCustomerName: this.paymentInfo.custName, bussUserId: this.paymentInfo.userId }).then(res => {
      //   if (res.code == 200) {
      //     this.execCustomerId = res.data.execCustomerId
      //     this.execCustomerName = res.data.execCustomerName
      //     this.agentBusinessMoney = res.data.agentBusinessMoney
      //   }
      // })
      this.execCustomerId = this.paymentInfo.execCustomerId
      this.execCustomerName = this.paymentInfo.execCustomerName
      this.agentBusinessMoney = this.paymentInfo.agentBusinessMoney
      await this.$refs.projectPointDetail.getProjectList(2, this.execCustomerId, this.execCustomerName, this.agentBusinessMoney)
    } else if (this.contInfo.channelType != 2) {
      this.execCustomerId = null
      this.execCustomerName = null
      await this.$refs.projectPointDetail.getProjectList(1, this.contInfo.contractId)
    }
  },
  mounted() {
    sessionStorage.setItem('rechargeSearch', true)
    this.init()
  },
  methods: {
    async init() {
      document.title = '充值详情'
    },
    async getContractInfo() {
      await newContract.getContract(this.$route.query.contractId).then(res => {
        if (res.code == 200) {
          this.contInfo = res.data
        }
      })
    },
    async getPointList() {
      if (this.contInfo.custSource == 2) {
        await payment.execListByContractId({ contractId: this.$route.query.contractId, companyName: this.paymentInfo.custName }).then(res => {
          if (res.code == 200) {
            this.pointList = res.data
          }
        })
      } else {
        await newContract.getRebateList({ contractId: this.$route.query.contractId }).then(res => {
          if (res.code == 200) {
            this.pointList = res.rows
          }
        })
      }
    },
    async getPaymentInfo() {
      // if (this.type === 'advances') {
      //   await advances.getNewIncomeDetail(this.mainDetailId).then(res => {
      //     if (res.code === 200) {
      //       this.paymentInfo = res.data
      //     }
      //   })
      // } else {
      if (this.type === 'advances' || this.type === 'paymentReject' || this.type === 'channelReject') {
        await advances.getItemById({ advancesRechargeId: this.mainDetailId, dataType: this.dataType }).then(res => {
          if (res.code === 200) {
            this.paymentInfo = res.data
          }
        })
      } else {
        await advances.getInfoById({ contAdvancesId: this.mainDetailId, dataType: this.dataType }).then(res => {
          if (res.code === 200) {
            this.paymentInfo = res.data
          }
        })
      }
      // }
      // const res = await api.getNewIncomeDetail(this.$route.query.contNewIncomeDetailId)
      // if (res.code === 200) {
      //   this.paymentInfo = res.data
      //   this.isShow = true
      // }
      this.isShow = true
      this.getLogList()
    },
    // async getRechargeInfo() {
    //   await api.mediaListNewIncomeDetail({ [this.typeDetailId]: this.$route.query.contNewIncomeDetailId }).then(res => {
    //     if (res.code == 200) {
    //       if (res.rows.length > 0) {
    //         this.paymentInfo = res.rows[0]
    //       }
    //     }
    //   })
    //   if (this.paymentInfo.execType != 0) {
    //     // await this.getExecutiveList(this.$route.query.contNewIncomeDetailId)
    //     // await this.getFlowList(this.$route.query.contNewIncomeDetailId)
    //   }
    // },
    async getExecutiveList(contNewIncomeDetailId) {
      await payment.listExecutiveNew({ contNewIncomeDetailId }).then(res => {
        if (res.code == 200) {
          this.executiveList = res.rows
        }
      })
    },
    // 获取充值列表信息
    async getRechargeList() {
      await payment.listExecAccount({ contNewIncomeDetailId: this.mainDetailId, dataType: this.dataType, isReject: this.paymentInfo.execType == 1 ? 2 : 1 }).then(res => {
        if (res.code == 200) {
          this.rechargeList = res.data
        }
      })
    },
    // 获取渠道分账列表信息
    async getChannelAccountList() {
      await channel.listAccount({ needDetailId: this.mainDetailId }).then(res => {
        if (res.code == 200) {
          this.channelAccountList = res.rows
        }
      })
    },
    async getRejectInfo() {
      await payment.getRejectMediaUser({ contNewIncomeDetailId: this.mainDetailId, dataType: this.dataType }).then(res => {
        if (res.code === 200) {
          this.rejectInfo = res.data
        }
      })
    },
    // async getFlowList(contNewIncomeDetailId) {
    //   await payment.listFlowList({ contIncomeId: contNewIncomeDetailId }).then(res => {
    //     if (res.code == 200) {
    //       this.flowList = res.rows
    //     }
    //   })
    // },
    // 获取操作记录
    async getLogList() {
      const params = {
        contractId: this.mainDetailId,
        bigType: 99
      }
      await newContract.listContractLog(params).then(response => {
        this.operationLogList = response.rows
      })
    },
    async onSearch() {
      await this.getAuthIds(this.rechargeForm.flowList[this.flowIndex].projectId)
      // this.accountNoList = this.accountNoList.filter(item => {
      //   return (item.accountId.toString()).indexOf(this.searchValue) > -1
      // })
      this.picker.columns = this.accountNoList.map((ele) => ele.accountId)
    },
    async showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'dept') {
        await listDept({ isBuss: '1' }).then(res => {
          this.deptList = res.data
        })
        this.picker.columns = this.deptList.map((ele) => ele.deptName)
        this.picker.loading = false
      } else if (type === 'user') {
        if (this.mediaVisible) {
          await payment.getListByUserId({ userId: this.paymentInfo.userId }).then(res => {
            if (res.code == 200) {
              this.userList = res.data
            }
          })
          this.picker.columns = this.userList.map((ele) => ele.userName)
        } else {
          await getUserDeptListByRole(this.paymentInfo.deptId).then(res => {
            if (res.code == 200) {
              this.userList = res.data
            }
          })
          this.picker.columns = this.userList.map((ele) => ele.nickName)
        }
        this.picker.loading = false
      } else if (type === 'accountNo') {
        this.picker.columns = this.accountNoList.map((ele) => ele.accountId)
        this.picker.loading = false
      } else if (type === 'execCustomer') {
        this.picker.columns = this.execCustomerList.map((ele) => ele.execCustomerName)
        this.picker.loading = false
      } else if (type === 'project') {
        this.picker.columns = this.projectList.map((ele) => ele.projectName)
        this.picker.loading = false
      } else if (type === 'execCustomers') {
        this.picker.columns = this.execCustomerList.map((ele) => ele.execCustomerName)
        this.picker.loading = false
      } else if (type === 'projects') {
        // if ((this.typeDetailId === 'contNewIncomeDetailId' && this.contInfo.channelType == 2)) {
        //   await this.getProjectList(2, this.rechargeForm.flowList[index].execCustomerId)
        // }
        this.picker.columns = this.projectList.map((ele) => `【${ele.percentage}%/${ele.calculationMethodStr}】${getValue(ele.projectName)} | ${ele.industryName ? ele.industryName : '-'}`)
        this.picker.loading = false
      } else if (type === 'serviceId') {
        this.picker.columns = this.serviceIdList.map((ele) => ele.accountId + '  ' + ele.remark)
        this.picker.loading = false
      } else if (type === 'subAccountId') {
        this.picker.columns = this.subAccountIdList.map((ele) => ele.accountId + '  ' + ele.remark)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      // const id = this.picker.formKey + 'Id'
      if (this.index || this.index == 0) {
        if (this.picker.formKey === 'accountNo') {
          if (this.authIdsForm.authIdsList.some(abc => { return abc.accountNo == this.accountNoList[key].accountId })) {
            Toast.fail('不能添加重复的账户ID')
            return
          }
          // this.accountNoList = this.accountNoList.filter(item => {
          //   return (item.accountId.toString()).indexOf(this.searchValue) > -1
          // })
          this.authIdsForm.authIdsList[this.index].accountNo = this.accountNoList[key].accountId
        } else if (this.picker.formKey === 'execCustomers') {
          if (this.rechargeForm.flowList[this.index].projectId && this.rechargeForm.flowList[this.index].projectName) {
            this.rechargeForm.flowList[this.index].projectId = null
            this.rechargeForm.flowList[this.index].projectName = null
          }
          await this.getProjectList(2, this.execCustomerList[key].execCustomerId)
          this.rechargeForm.flowList[this.index].execCustomerId = this.execCustomerList[key].execCustomerId
          this.rechargeForm.flowList[this.index].execCustomerName = this.execCustomerList[key].execCustomerName
          // this.execCustomerId = this.execCustomerList[key].execCustomerId
          // this.execCustomerName = this.execCustomerList[key].execCustomerName
          if (this.projectList.length == 1) {
            this.rechargeForm.flowList[this.index].projectId = this.projectList[0].projectId
            this.rechargeForm.flowList[this.index].projectName = this.projectList[0].projectName
          }
          this.getProjectList(2, this.execCustomerList[key].execCustomerId)
        } else if (this.picker.formKey === 'projects') {
          this.rechargeForm.flowList[this.index].projectId = this.projectList[key].projectId
          this.rechargeForm.flowList[this.index].projectName = this.projectList[key].projectName
        } else if (this.picker.formKey === 'serviceId') {
          this.rechargeForm.execAccountList[this.index].serviceName = this.serviceIdList[key].accountId + '  ' + this.serviceIdList[key].remark
          this.rechargeForm.execAccountList[this.index].serviceId = this.serviceIdList[key].accountId
        } else if (this.picker.formKey === 'subAccountId') {
          this.rechargeForm.execAccountList[this.index].subAccountName = this.subAccountIdList[key].accountId + '  ' + this.subAccountIdList[key].remark
          this.rechargeForm.execAccountList[this.index].subAccountId = this.subAccountIdList[key].accountId
        } else if (this.picker.formKey === 'tenFundType') {
          this.rechargeForm.execAccountList[this.index].tenFundType = this.options[optionItem][key].dictValue
          this.rechargeForm.execAccountList[this.index].tenFundTypeName = this.options[optionItem][key].dictLabel
        } else {
          this.rechargeForm.flowList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.rechargeForm.flowList[this.index][name] = this.options[optionItem][key].dictLabel
        }
      } else {
        if (this.picker.formKey === 'dept') {
          this.mediaForm.deptId = this.deptList[key].deptId
          this.mediaForm.deptName = this.deptList[key].deptName
        } else if (this.picker.formKey === 'user') {
          if (this.mediaVisible) {
            this.mediaForm.userId = this.userList[key].userId
            this.mediaForm.userName = this.userList[key].userName
          } else {
            this.designatedForm.mediaUserId = this.userList[key].userId
            this.designatedForm.mediaUserName = this.userList[key].nickName
          }
        } else if (this.picker.formKey === 'execCustomer') {
          this.bindForm.execCustomerId = this.execCustomerList[key].execCustomerId
          this.bindForm.execCustomerName = this.execCustomerList[key].execCustomerName
          this.getProjectList(2, this.execCustomerList[key].execCustomerId)
        } else if (this.picker.formKey === 'project') {
          this.bindForm.projectId = this.projectList[key].projectId
          this.bindForm.projectName = this.projectList[key].projectName
        } else if (this.picker.formKey === 'serviceId') {
          this.mediaRechargeForm.serviceName = this.serviceIdList[key].accountId + '  ' + this.serviceIdList[key].remark
          this.mediaRechargeForm.serviceId = this.serviceIdList[key].accountId
          await this.getAccountBalance()
        } else if (this.picker.formKey === 'subAccountId') {
          this.mediaRechargeForm.subAccountName = this.subAccountIdList[key].accountId + '  ' + this.subAccountIdList[key].remark
          this.mediaRechargeForm.subAccountId = this.subAccountIdList[key].accountId
        } else if (this.picker.formKey === 'tenFundType') {
          this.mediaRechargeForm.tenFundType = this.options[optionItem][key].dictValue
          this.mediaRechargeForm.tenFundTypeName = this.options[optionItem][key].dictLabel
        } else {
          this.bindForm[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.bindForm[name] = this.options[optionItem][key].dictLabel
        }
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    showCalendar(type) {
      this.datePicker.formKey = type
      this.datePicker.type = 'single'
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      // this.minDate = date
      this.bindForm[this.datePicker.formKey] = this.formatDate(date)
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    // 获取项目名称列表
    async getProjectList(type, id) {
      await newContract.listProjectPercentage({ bussType: type, bussId: id }).then(res => {
        if (res.code == 200) {
          this.projectList = res.data
        }
      })
    },
    // async handleBinding() {
    //   await this.getProjectList(this.typeDetailId === 'needDetailId' ? 2 : 1, this.typeDetailId === 'needDetailId' ? this.contInfo.execCustomerId : this.paymentInfo.contractId)
    //   if (this.contInfo.channelType == 2) {
    //     await payment.listExecutive({ contractId: this.contInfo.contractId }).then(res => {
    //       if (res.code == 200) {
    //         this.execCustomerList = res.rows
    //       }
    //     })
    //     this.projectList = []
    //     if (this.execCustomerList.length == 1) {
    //       this.bindForm.execCustomerId = this.execCustomerList[0].execCustomerId
    //       this.bindForm.execCustomerName = this.execCustomerList[0].execCustomerName
    //       await this.getProjectList(2, this.bindForm.execCustomerId)
    //     }
    //   }
    //   if (this.projectList.length == 1) {
    //     this.bindForm.projectId = this.projectList[0].projectId
    //     this.bindForm.projectName = this.projectList[0].projectName
    //   }
    //   if (this.contInfo.channelType == 3) {
    //     this.bindForm.execCustomerId = this.paymentInfo.execCustomerId
    //   }
    //   this.bindVisible = true
    // },
    // 绑定账户ID
    // async bindBeforeClose(type, done) {
    //   if (type === 'confirm') {
    //     try {
    //       await this.$refs.bindForm.validate()
    //       this.bindForm.contractId = this.contractId
    //       if (this.typeDetailId == 'contNewIncomeDetailId') {
    //         this.bindForm.dataType = 1
    //       } else if (this.typeDetailId == 'needDetailId') {
    //         this.bindForm.dataType = 2
    //       } else {
    //         this.bindForm.dataType = 3
    //       }
    //       payment.addAssociation(this.bindForm).then(response => {
    //         if (response.code === 200) {
    //           Toast.success('绑定账户ID成功')
    //           this.bindResult = response.msg
    //           this.bindResultVisible = true
    //           this.bindVisible = false
    //           this.bindForm = {
    //             execCustomerId: null,
    //             execCustomerName: null,
    //             projectId: null,
    //             projectName: null,
    //             accountType: 1,
    //             accountTypeName: '腾讯',
    //             startDateStr: null,
    //             endDateStr: null,
    //             accountIds: null,
    //             dataType: null
    //           }
    //           // this.getRechargeInfo()
    //           this.getPaymentInfo()
    //           done()
    //         } else {
    //           Toast.fail(response.msg)
    //         }
    //       })
    //     } catch (err) {
    //       return done(false)
    //     }
    //     return done(false)
    //   } else {
    //     return done()
    //   }
    // },
    // 指定媒介人员
    designatedMedia() {
      this.designatedVisible = true
    },
    async saveDesignated(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.designatedForm.validate()
          this.designatedForm.contNewIncomeDetailId = this.mainDetailId
          this.designatedForm.dataType = this.dataType
          payment.designatedMedia(this.designatedForm).then(res => {
            if (res.code == 200) {
              Toast.success('指定媒介人员成功')
              setTimeout(async() => {
                this.designatedVisible = false
                // await this.getRechargeInfo()
                await this.getPaymentInfo()
                if (this.paymentInfo.rechargeStatus != 1) {
                  await this.getRechargeList()
                }
                if (this.paymentInfo.execType == 1) {
                  await this.getRejectInfo()
                }
                done()
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    handleTransfer() {
      payment.listDept().then(response => {
        if (response.code == 200) {
          if (response.data.length > 0 && response.data[0].id != 1) {
            this.mediaForm.deptId = response.data[0].id
            this.mediaForm.deptName = response.data[0].label
          }
        }
      })
      this.mediaVisible = true
    },
    // 转其他媒介人员
    async mediaBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.mediaForm.validate()
          const data = {
            advancesRechargeId: this.mainDetailId,
            mediaUserId: this.mediaForm.userId,
            mediaUserName: this.mediaForm.userName,
            newMediaUserId: this.paymentInfo.mediaUserId,
            newMediaUserName: this.paymentInfo.mediaUserName
          }
          advances.updateNewIncomeDetail(data).then(res => {
            if (res.code == 200) {
              Toast.success('指定媒介人员成功')
              setTimeout(async() => {
                this.mediaVisible = false
                // await this.getRechargeInfo()
                await this.getPaymentInfo()
                if (this.paymentInfo.rechargeStatus != 1) {
                  await this.getRechargeList()
                }
                if (this.paymentInfo.execType == 1) {
                  await this.getRejectInfo()
                }
                done()
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    async handleRecharge() {
      // const result = await payment.isMediaUser({ contNewIncomeDetailId: this.paymentInfo[this.typeDetailId], dataType: this.typeDetailId === 'contNewIncomeDetailId' ? 1 : 2 })
      // if (!result.data) {
      //   Dialog.alert({
      //     title: '提示',
      //     message: '该部门未设置媒介排班人员，请先联系媒介排班负责人设置排班再进行充值执行！'
      //   }).then(() => {

      //   })
      //   return
      // }
      // await this.getProjectList(this.typeDetailId === 'needDetailId' ? 2 : 1, this.typeDetailId === 'needDetailId' ? this.contInfo.execCustomerId : this.paymentInfo.contractId)
      // if (this.type == 'advances' && this.paymentInfo.custSource == 2) {
      //   await payment.listExecutive({ contractId: this.contInfo.contractId }).then(res => {
      //     if (res.code == 200) {
      //       this.execCustomerList = res.rows
      //     }
      //   })
      //   // this.projectList = []
      // }
      this.rechargeForm = {
        dataType: null,
        contractId: null,
        contNewIncomeDetailId: null,
        flowList: [],
        payMoney: null,
        rechargeMoney: null
      }
      this.rechargeForm.flowList = []
      if (this.paymentInfo.execType == 1) {
        await this.getRejectList()
      } else {
        // await this.setFlowList()
      }
      if ((this.type == 'advances') && this.paymentInfo.custSource == 2) {
        this.execCustomerId = this.paymentInfo.execCustomerId
        this.execCustomerName = this.paymentInfo.execCustomerName
        await this.getProjectList(2, this.paymentInfo.execCustomerId)
      } else if (((this.type === 'payment' || this.type === 'paymentReject') && this.contInfo.channelType == 2) || this.type === 'channel' || this.type === 'channelReject') {
        this.execCustomerId = this.paymentInfo.execCustomerId
        this.execCustomerName = this.paymentInfo.execCustomerName
        this.agentBusinessMoney = this.paymentInfo.agentBusinessMoney
        await this.getProjectList(2, this.paymentInfo.execCustomerId)
      } else if (this.contInfo.channelType != 2) {
        this.execCustomerId = null
        this.execCustomerName = null
        await this.getProjectList(1, this.contInfo.contractId)
      }
      this.rechargeVisible = true
    },
    async setFlowList() {
      await channel.listCapitalFlow({ needDetailId: this.mainDetailId, dataType: this.dataType }).then(res => {
        if (res.code == 200) {
          this.rechargeForm.flowList = res.rows
          this.rechargeForm.flowList.forEach(item => {
            item.fundTypeName = this.options.fundTypeOptions.find(i => { return item.fundType == i.dictValue }).dictLabel
          })
        } else {
          Toast.fail(res.msg)
        }
      })
      this.rechargeForm.rechargeMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
      this.rechargeForm.payMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.payMoney), 0)
    },
    async getRejectList() {
      await payment.listFlowReject({ contNewIncomeDetailId: this.mainDetailId, dataType: this.dataType }).then(res => {
        if (res.code == 200) {
          this.rechargeForm.flowList = res.data
          this.rechargeForm.flowList.forEach(item => {
            item.fundTypeName = this.options.fundTypeOptions.find(i => { return item.fundType == i.dictValue }).dictLabel
          })
        }
      })
      this.rechargeForm.rechargeMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
      this.rechargeForm.payMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.payMoney), 0)
      // this.$set(this.rechargeForm)
    },
    async addExecutive() {
      const obj = {}
      // if (this.contInfo.businessTypeName.indexOf('效果运营类') > -1) {
      //   if (this.contInfo.operationMode == 2) {
      //     obj.fundType = 1
      //     obj.fundTypeName = '代运营充值'
      //   } else {
      //     obj.fundType = 2
      //     obj.fundTypeName = '媒介充值'
      //   }
      // } else if (this.contInfo.businessTypeName.indexOf('数字媒介类') > -1) {
      //   obj.fundType = 2
      //   obj.fundTypeName = '媒介充值'
      // }
      if (this.type === 'advances' && this.paymentInfo.custSource == 2) {
        obj.execCustomerId = this.execCustomerId
        obj.execCustomerName = this.execCustomerName
        await this.getProjectList(2, this.execCustomerId)
      } else if (this.type === 'advances' && this.paymentInfo.custSource == 1) {
        await this.getProjectList(1, this.contInfo.contractId)
      } else if (((this.type === 'payment' || this.type === 'paymentReject') && this.contInfo.channelType == 2)) {
        obj.execCustomerId = this.execCustomerId
        obj.execCustomerName = this.execCustomerName
        await this.getProjectList(2, this.execCustomerId)
      }
      if (this.projectList.length == 1) {
        obj.projectId = this.projectList[0].projectId
        obj.projectName = this.projectList[0].projectName
        if (obj.projectName.indexOf('代运营') > -1) {
          obj.fundType = 1
          obj.fundTypeName = '代运营充值'
        } else {
          obj.fundType = 2
          obj.fundTypeName = '媒介充值'
        }
      }
      this.rechargeForm.flowList.push({
        fundType: obj.fundType || null,
        fundTypeName: obj.fundTypeName || null,
        execCustomerId: obj.execCustomerId || null,
        execCustomerName: obj.execCustomerName || null,
        projectId: obj.projectId || null,
        projectName: obj.projectName || null,
        authIds: null,
        rechargeMoney: null,
        payMoney: null,
        authIdsList: [{
          accountNo: null,
          payMoney: null,
          rechargeMoney: null
        }]
      })
      // if (this.typeDetailId == 'advancesRechargeId' && this.paymentInfo.custSource == 2) {
      //   await this.getProjectList(2, this.execCustomerId)
      // }
      const res = this.activeNames.some(item => {
        return this.rechargeForm.flowList.length - 1 === item
      })
      if (res === false) {
        this.activeNames.push(this.rechargeForm.flowList.length - 1)
      }
    },
    delExecutive(index) {
      if (this.rechargeForm.flowList.length > 0) {
        this.rechargeForm.flowList.splice(index, 1)
        this.rechargeForm.rechargeMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
        this.rechargeForm.payMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.payMoney), 0)
      }
    },
    async selectAuthIds(index) {
      if (!this.rechargeForm.flowList[index].projectId) {
        Toast.fail('请先选择项目名称')
        return false
      }
      this.authIdsForm.accountMoney = 0
      this.authIdsForm.rechargeMoney = 0
      this.authIdsForm.authIdsList = [{
        accountNo: null,
        payMoney: null,
        rechargeMoney: null
      }]
      this.authIdQuery.projectId = this.rechargeForm.flowList[index].projectId
      await this.getAuthIds(this.rechargeForm.flowList[index].projectId)
      this.flowIndex = index
      if ((this.paymentInfo.execType || this.paymentInfo.execType == 0) && (this.paymentInfo.execType == 0 || this.paymentInfo.execType == 1)) {
        if (this.rechargeForm.flowList.length > 0 && this.rechargeForm.flowList[index].authIdsList) {
          this.authIdsForm.authIdsList = this.rechargeForm.flowList[index].authIdsList
        }
        this.authIdsForm.payMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.payMoney), 0)
        this.authIdsForm.rechargeMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
      }
      this.authIdsVisible = true
    },
    async getAuthIds(projectId) {
      await payment.listByProjectId(this.authIdQuery).then(res => {
        if (res.code == 200) {
          this.accountNoList = res.data
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    handleAccountID() {
      const params = {
        contractId: this.contInfo.contractId,
        projectId: this.rechargeForm.flowList[this.flowIndex].projectId,
        projectName: this.rechargeForm.flowList[this.flowIndex].projectName,
        endDateStr: this.contInfo.endTime,
        execCustomerId: this.execCustomerId || null,
        execCustomerName: this.execCustomerName || null,
        dataType: this.contInfo.channelType == 3 ? 2 : 1
      }
      this.$refs.accountId.handleAccountID(params, 'direct')
    },
    addAuthId() {
      this.authIdsForm.authIdsList.push({
        accountNo: null,
        payMoney: null,
        rechargeMoney: null,
        fundType: this.rechargeForm.flowList[this.flowIndex].fundType,
        money: this.paymentInfo.paySurplusMoney
      })
      const res = this.activeNamesID.some(item => {
        return this.authIdsForm.authIdsList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesID.push(this.authIdsForm.authIdsList.length - 1)
      }
    },
    delAuthId(index) {
      if (this.authIdsForm.authIdsList.length > 0) {
        this.authIdsForm.authIdsList.splice(index, 1)
      }
      this.authIdsForm.payMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.payMoney), 0)
      this.authIdsForm.rechargeMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
    },
    async getPayMoney(type, val, index) {
      const params = {
        payMoney: null,
        rechargeMoney: null,
        fundType: this.rechargeForm.flowList[this.flowIndex].fundType,
        projectId: this.rechargeForm.flowList[this.flowIndex].projectId,
        contractId: this.contInfo.contractId
      }
      if (type == 'payMoney') {
        params.payMoney = val
        params.rechargeMoney = null
        await channel.getPayMoney(params).then(res => {
          if (res.code == 200) {
            this.authIdsForm.authIdsList[index].rechargeMoney = res.data
          }
        })
      } else if (type == 'rechargeMoney') {
        params.payMoney = null
        params.rechargeMoney = val
        await channel.getPayMoney(params).then(res => {
          if (res.code == 200) {
            this.authIdsForm.authIdsList[index].payMoney = res.data
          }
        })
      }
      this.authIdsForm.payMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.payMoney), 0)
      this.authIdsForm.rechargeMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
    },
    async authIdsBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.authIdsForm.validate()
          this.authIdsForm.authIdsList[0].fundType = this.rechargeForm.flowList[this.flowIndex].fundType
          this.authIdsForm.authIdsList[0].money = this.paymentInfo.preRechargeMoney
          await payment.getExecBatch(this.authIdsForm.authIdsList).then(res => {
            if (res.code == 200) {
              this.rechargeForm.flowList[this.flowIndex].authIds = res.data.authIds
              this.rechargeForm.flowList[this.flowIndex].rechargeMoney = res.data.rechargeMoney
              this.rechargeForm.flowList[this.flowIndex].payMoney = res.data.payMoney
              this.rechargeForm.payMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.payMoney), 0)
              this.rechargeForm.rechargeMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
              this.authIdsVisible = false
              this.rechargeForm.flowList[this.flowIndex].authIdsList = this.authIdsForm.authIdsList
              done()
            } else {
              Toast.fail(res.msg)
            }
          })
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    getAllPayMoney(index) {
      if (index == this.rechargeForm.flowList.length - 1) {
        this.rechargeForm.payMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.payMoney), 0)
      }
    },
    // 在线充值
    async saveRechargeOnline() {
      if (this.rechargeForm.flowList.length === 0) {
        Toast.fail('请先添加充值明细')
        return
      }
      await this.$refs.rechargeForm.validate()
      this.rechargeForm.execAccountList = []
      this.rechargeForm.flowList.forEach(item => {
        Array.prototype.push.apply(this.rechargeForm.execAccountList, item.authIdsList)
      })
      await payment.listGroupAccountId({ accountId: this.rechargeForm.execAccountList[0].accountNo }).then(res => {
        if (res.code === 200) {
          this.getContTencentAccountTokenList(res.data.rows[0].accountType)
          this.accountType = res.data.rows[0].accountType
        }
      })
      this.rechargeForm.execAccountList.forEach(item => {
        item.mediaRechargeType = 1
        if (this.accountType === 1) {
          item.tenFundType = 'FUND_TYPE_CASH'
          item.tenFundTypeName = '现金账户'
        }
      })
      const res = this.activeNamesOnline.some(item => {
        return this.rechargeForm.execAccountList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesOnline.push(this.rechargeForm.execAccountList.length - 1)
      }
      this.onlineVisible = true
    },
    setType() {
      this.$forceUpdate()
    },
    saveOnline() {
      this.rechargeForm.onLineType = 2
      this.rechargeForm.contractId = this.contractId
      this.rechargeForm.bussId = this.mainDetailId
      this.rechargeForm.companyName = this.paymentInfo.custName
      this.rechargeForm.dataType = this.dataType
      if (this.type === 'advancesReject' || this.type === 'paymentReject' || this.type === 'channelReject') {
        this.rechargeForm.isAdvancesReject = 1
      } else {
        this.rechargeForm.isAdvancesReject = null
      }
      payment.addFlowNew(this.rechargeForm).then(res => {
        if (res.code == 200) {
          if (res.data) {
            Toast.success('充值申请成功')
            this.resultList = res.data
            setTimeout(async() => {
              this.onlineVisible = false
              this.rechargeVisible = false
              this.resultVisible = true
              // await this.getRechargeInfo()
              await this.getPaymentInfo()
              if (this.paymentInfo.rechargeStatus != 1) {
                await this.getRechargeList()
              }
              if (this.paymentInfo.execType == 1) {
                await this.getRejectInfo()
              }
            }, 1500)
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 媒介充值申请
    async saveRecharge() {
      if (this.rechargeForm.flowList.length === 0) {
        Toast.fail('请先添加充值明细')
        return
      }
      await this.$refs.rechargeForm.validate()
      this.rechargeForm.contractId = this.contractId
      this.rechargeForm.bussId = this.mainDetailId
      this.rechargeForm.companyName = this.paymentInfo.custName
      this.rechargeForm.dataType = this.dataType
      if (this.type === 'advancesReject' || this.type === 'paymentReject' || this.type === 'channelReject') {
        this.rechargeForm.isAdvancesReject = 1
      } else {
        this.rechargeForm.isAdvancesReject = null
      }
      payment.addFlowNew(this.rechargeForm).then(res => {
        if (res.code == 200) {
          if (res.data.mediaUserName) {
            // Toast.success('充值申请成功,当前媒介排班人员为：' + res.data.mediaUserName)
            Dialog.alert({
              message: '充值申请成功,当前媒介排班人员为：' + res.data.mediaUserName
            }).then(() => {
              // on close
            })
            setTimeout(async() => {
              if (this.type == 'payment') {
                this.type = 'paymentReject'
              } else if (this.type == 'channel') {
                this.type = 'channelReject'
              }
              this.mainDetailId = res.data.advancesRechargeId
              // await this.getRechargeInfo()
              await this.getPaymentInfo()
              if (this.paymentInfo.rechargeStatus != 1) {
                await this.getRechargeList()
              }
              if (this.paymentInfo.execType == 1) {
                await this.getRejectInfo()
              }
              this.rechargeVisible = false
            }, 1500)
          } else {
            Toast.fail('当前时段内未查询到排班人员，请指定媒介人员进行充值')
            if (this.type == 'payment') {
              this.type = 'paymentReject'
            } else if (this.type == 'channel') {
              this.type = 'channelReject'
            }
            this.mainDetailId = res.data.advancesRechargeId
            setTimeout(async() => {
              // await this.getRechargeInfo()
              await this.getPaymentInfo()
              if (this.paymentInfo.rechargeStatus != 1) {
                await this.getRechargeList()
              }
              if (this.paymentInfo.execType == 1) {
                await this.getRejectInfo()
              }
              this.rechargeVisible = false
              this.designatedMedia()
            }, 1500)
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    handleAuthIdDetail(contIncomeId) {
      payment.listExecAccount({ contNewIncomeDetailExecId: contIncomeId }).then(res => {
        if (res.code == 200) {
          this.authIdsDetailList = res.rows
          this.authIdsDetailVisible = true
        }
      })
    },
    showImg(val) {
      this.imageArr = []
      this.imageArr.push(val)
      this.imageShow = true
    },
    showTimePicker(type) {
      this.datetimePicker.formKey = type
      this.datetimePicker.showDate = true
    },
    datetimePickerConfirm(date) {
      this.mediaRechargeForm[this.datetimePicker.formKey] = this.formatDateTime(date)
      this.datetimePicker.showDate = false
    },
    formatDateTime(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      var minute = date.getMinutes()
      minute = minute < 10 ? ('0' + minute) : minute
      var second = date.getSeconds()
      second = second < 10 ? ('0' + second) : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    },
    // 媒介充值
    async handleMediaRecharge(row, type) {
      this.mediaRechargeForm = {
        serviceId: null,
        mediaRechargeType: 1,
        consumeDate: null,
        subAccountId: null,
        mediaUrl: null,
        tenFundType: null,
        ids: []
      }
      await this.getContTencentAccountTokenList(row.accountType)
      this.mediaRechargeForm.ids.push(row.contNewIncomeDetailExecAccountId)
      if (type === 'online') {
        this.mediaRechargeForm.onLineType = 2
      } else {
        this.mediaRechargeForm.onLineType = null
        this.mediaRechargeForm.consumeDate = this.formatDateTime(new Date())
      }
      this.mediaRechargeForm.accountType = row.accountType
      if (row.serviceId) {
        this.mediaRechargeForm.serviceId = row.serviceId
        this.mediaRechargeForm.serviceName = row.serviceId
        await this.getAccountBalance()
      }
      if (row.subAccountId) {
        this.mediaRechargeForm.mediaRechargeType = 2
        this.mediaRechargeForm.subAccountId = row.subAccountId
        this.mediaRechargeForm.subAccountName = row.subAccountId
      }
      this.mediaRechargeVisible = true
    },
    async getAccountBalance() {
      let serviceId = null
      serviceId = this.mediaRechargeForm.serviceId
      await advances.getAccountBalance({ accountId: serviceId, accountType: this.mediaRechargeForm.accountType, serviceId: serviceId }).then(res => {
        if (res.code === 200) {
          this.accountBalance = res.data
        }
      })
    },
    async handleMediaRechargeAll() {
      if (this.checkGroup.length == 0) {
        Toast.fail('请至少勾选一条充值分账明细数据')
        return false
      }
      await this.getContTencentAccountTokenList(this.rechargeList[0].accountType)
      this.mediaRechargeForm = {
        serviceId: null,
        mediaRechargeType: 1,
        consumeDate: null,
        subAccountId: null,
        mediaUrl: null,
        tenFundType: null,
        ids: []
      }
      this.mediaRechargeForm.ids = this.checkGroup
      this.mediaRechargeVisible = true
    },
    async getContTencentAccountTokenList(accountType) {
      await payment.getContTencentAccountTokenList({ accountType }).then(res => {
        if (res.code === 200) {
          this.serviceIdList = res.data
        }
      })
      await payment.getSubAccountTokenList({ accountType }).then(res => {
        if (res.code === 200) {
          this.subAccountIdList = res.data
        }
      })
      if (this.serviceIdList.length == 1) {
        this.mediaRechargeForm.serviceId = this.serviceIdList[0].accountId
      }
      if (accountType === 1) {
        await this.getDicts('finance_account_type').then(res => {
          this.options.tenFundTypeOptions = res.data
          this.mediaRechargeForm.tenFundType = 'FUND_TYPE_CASH'
          this.mediaRechargeForm.tenFundTypeName = '现金账户'
        })
      }
    },
    async searchSubAccountId() {
      await payment.getSubAccountTokenList({ accountType: this.rechargeList[0].accountType }).then(res => {
        if (res.code === 200) {
          this.subAccountIdList = res.data
        }
      })
      this.subAccountIdList = this.subAccountIdList.filter(item => {
        return (item.accountId.toString()).indexOf(this.queryAccountId) > -1
      })
      this.picker.columns = this.subAccountIdList.map((ele) => ele.accountId + '  ' + ele.remark)
    },
    // 返回布尔值
    beforeRead(file) {
      const imgArr = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/vnd.adobe.photoshop']
      if (!imgArr.some((item) => { return file.type === item })) {
        Toast('请上传 图片 文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast('文件大小不能超过 10mb')
    },
    async uploadPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.mediaRechargeForm.mediaUrl = res.url
            this.pictureList = []
            this.pictureList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    handleRemove(file) {
      this.mediaRechargeForm.mediaUrl = ''
      this.pictureList = []
      return true
    },
    async saveMediaRecharge(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.mediaRechargeForm.validate()
          payment.mediaConfirm(this.mediaRechargeForm).then(response => {
            if (response.code === 200) {
              Toast.success('媒介充值成功')
              this.getPaymentInfo()
              this.getRechargeList()
              this.mediaRechargeVisible = false
              this.mediaRechargeForm = {
                serviceId: null,
                mediaRechargeType: 1,
                consumeDate: null,
                subAccountId: null,
                mediaUrl: null,
                tenFundType: null,
                ids: []
              }
              this.pictureList = []
              done()
            } else {
              Toast.fail(response.msg)
            }
          })
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    handleReject(row) {
      this.rejectVisible = true
      this.rejectForm.contNewIncomeDetailExecAccountId = row.contNewIncomeDetailExecAccountId
      this.rejectForm.mediaRejectReason = null
    },
    async saveReject(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.rejectForm.validate()
          const response = await payment.mediaRejectNew(this.rejectForm)
          if (response.code === 200) {
            Toast.success('驳回操作成功')
            setTimeout(async() => {
              await this.getPaymentInfo()
              await this.getRechargeList()
              await this.getRejectInfo()
              done()
            }, 500)
            done()
          } else {
            Toast.fail(response.msg)
          }
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    // 退款
    handleRefund(row) {
      this.$refs.refund.handleRefund(row)
    },
    // 批量退款给客户
    handleBatchRefund() {
      if (this.paymentInfo.rechargeRemainMoney < 0) {
        Toast.fail('充值剩余金额小于0，不允许退款申请')
        return
      }
      if (this.checkGroup.length == 0) {
        Toast.fail('请至少勾选一条充值分账明细数据')
        return false
      }
      const obj = { batchRefundList: this.checkGroup, custName: this.paymentInfo.custName, rechargeRemainMoney: this.paymentInfo.rechargeRemainMoney }
      this.$refs.batchRefund.handleBatchRefund(obj)
    },
    async getOptions() {
      // 框架类型
      await this.getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = res.data
      })
      // 客户来源类型
      await this.getDicts('cust_source').then(res => {
        this.options.custSourceOptions = res.data
      })
      // 垫款方式
      await this.getDicts('pay_type').then(res => {
        this.options.payTypeOptions = res.data
      })
      await this.getDicts('credit_cycle_type').then(res => {
        this.options.creditCycleTypeOptions = res.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

.editClue /deep/.van-dialog__content {
  height: 82%;
}
.editClue /deep/.van-dialog__footer{
  display: none;
}
.footer{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 33.3%;
    border: 1px #f4f4f4 solid;
  }
}
.footer2{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 50%;
    border: 1px #f4f4f4 solid;
  }
}

/deep/.van-dialog__confirm{
  color: #ee0a24;
  border-top: 0.01333rem solid #ccc;
}
.verifyClue /deep/.van-dialog__content {
  height: 80%;
}
.verifyClue /deep/.van-dialog__header {
  background-color: #d4d4d4;
}
.mediaRecharge_form /deep/.van-dialog__content {
  height: 73%;
}
.reject_form /deep/.van-dialog__content {
  height: 43%;
}
.media /deep/.van-dialog__content {
  height: 67%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
/deep/.van-list{
  padding: 0;
}
.tagTitle{
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
}
.contract_detail{
  .item{
    display: inline-block;
    width: 100%;
  }
  .value{
    color: #333;
  }
}
/deep/ .van-collapse-item__title{
  border-bottom: dashed 5px #1989fa;
}
.list_title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .van-icon{
    margin: 0 16px;
  }
}
.money_total{
  width: 95%;
  margin: 20px auto;
  background-color: #C6E2FF;
  border-radius: 10px;
  padding: 30px 10px 20px;
  font-size: 32px;
  .totle_divider{
    width: 98%;
    height: 4px;
    margin: 0 auto;
    background-color: #fff;
  }
  .total_title{
    padding-bottom: 10px;
    color: #ee0a24;
    text-align: center;
    letter-spacing: 30px;
    font-weight: bold;
  }
  .item{
    margin: 20px;
    font-size: 28px;
    .key{
      color: #0000FF;
    }
    .value{
      line-height: 42px;
    }
  }
}
.tag_button{
  line-height: 50px;
  margin-left: 20px;
  width: 100px;
  justify-content: center;
}

.authId_topBtn{
  width: 30%;
  margin: 0px auto 20px;
}
.pictureList{
  margin-left: 30px;
  margin-top: 10px;
}

.vant-table{
  margin-top: 15px;
  background-color: #fff;
  // padding: 20px;
  padding-bottom: 120px;
  /deep/ .van-cell{
    padding: 20px 10px 20px 30px;
  }
  .table {
    border: 2px solid #ddd;
    line-height: 65px;
    font-size: 28px;
    text-align: center;
    color: #666;
    .th {
      font-weight: 400;
      border-right: 2px solid #ddd;
    }
    .th:last-child {
      border-right: none;
    }
    .list-tr{
      /deep/ .van-field__label{
        width: 30px;
      }
    }
    .list-tr:hover {
      background-color: #f5f5f5;
    }
    td {
      border-top: 2px solid #ddd;
      border-right: 2px solid #ddd;
    }
    td:last-child {
      border-right: none;
    }
  }
}
</style>
